import React from "react";
import { withRouter } from "react-router";
import { Layout } from "antd";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import "./style/index.css";
import { connect } from "react-redux";
import AddTI from "./Components/AddTI";
import AddETO from "./Components/AddETO";
import ListTI from "./Components/ListTI";
import EditTI from "./Components/EditTI";
import ListETO from "./Components/ListETO";
import EditETO from "./Components/EditETO";
import LookupTable from "./Components/LookupTable";
import LookupTableEdit from "./Components/LookupTableEdit";
import PropertiesRegisteration from "./Components/PropertiesRegisteration";
import { AccountSettings } from "./Components/AccountSettings";

import AdminReports from "./Components/AdminReports";
import ReportsOverviewPdf from "./Components/Properties/Forms/ETOreportPdf";
import ZonesReports from "./Components/reports/zoneReports";
import CircleReport from "./Components/reports/circlesReport";
import ZoneReportPdf from "./Components/Properties/Forms/ZoneReportPdf";
import CircleReportPdf from "./Components/Properties/Forms/CircleReportPdf";
import ReportsTaxInspector from "./Components/reports/taxInspector";
import TIReportPdf from "./Components/Properties/Forms/TIReportPdf";
import HomePage from "./Components/HomePage";
import ActivityLogs from "./Components/User/ActivityLogs";
import AdminActivityLogs from "./Components/User/AdminActivityLogs";
import UploadData from "./Components/UploadLookupData/UploadData";
import DistrictAdminList from "./Components/DistrictAdminList";
import AddDistrictAdmin from "./Components/AddDistrictAdmin";
import EditDistrictAdmin from "./Components/EditDistrictAdmin";
import DcRateHistory from "./Components/DcRateHistory";


const DashboardAdmin = ({ history, user, notificationToggle }) => {
  const [isDistrictAdmin] = React.useState(user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id === 5) >=
	0 ? true : false);
	
  return (
    <Switch>
      <Route exact path="/" render={() => <Redirect to="/admin/home" />} />
      <Route exact path="/login" render={() => <Redirect to="/admin/home" />} />
      <Route exact path="/admin/home">
        <HomePage />
      </Route>
      <Route exact path="/admin/eto">
        <ListETO />
      </Route>
      {!isDistrictAdmin && <Route exact path="/admin/district-admin">
        <DistrictAdminList />
      </Route>}
      <Route exact path="/admin/add-eto">
        <AddETO />
      </Route>
      {!isDistrictAdmin && <Route exact path="/admin/add-district-admin">
        <AddDistrictAdmin />
      </Route>}
      {!isDistrictAdmin && <Route exact path="/admin/edit-district-admin">
        <EditDistrictAdmin />
      </Route>}
      <Route exact path="/admin/edit-eto">
        <EditETO />
      </Route>
      <Route exact path="/admin/tax-inspectors">
        <ListTI />
      </Route>
      <Route exact path="/admin/add-tax-inspector">
        <AddTI />
      </Route>
      <Route exact path="/admin/edit-tax-inspector">
        <EditTI />
      </Route>
      <Route exact path="/admin/lookup-table">
        <LookupTable />
      </Route>
      <Route exact path="/admin/upload-lookup-data">
        <UploadData />
      </Route>
      <Route exact path="/admin/update-lookup-record">
        <LookupTableEdit />
      </Route>
      <Route exact path="/admin/dc-record-history">
        <DcRateHistory />
      </Route>
      <Route exact path="/admin/properties">
        <PropertiesRegisteration />
      </Route>
      <Route exact path="/admin/overview">
        <AdminReports />
      </Route>
      <Route path="/reports/overview-pdf/:id">
        <ReportsOverviewPdf />
      </Route>
      <Route path="/reports/taxInspector-pdf/:selectedTi/circle/:selectedCircle">
        <TIReportPdf />
      </Route>
      <Route exact path="/account-settings/:id">
        <AccountSettings isAdmin={true} />
      </Route>
      <Route path="/reports/taxInspector">
        <ReportsTaxInspector />
      </Route>
      <Route path="/reports/zone/:id">
        <ZonesReports />
      </Route>
      <Route path="/reports/circle/:id">
        <CircleReport />
      </Route>
      <Route path="/reports/zone-pdf/:id">
        <ZoneReportPdf />
      </Route>
      <Route path="/reports/circle-pdf/:id">
        <CircleReportPdf />
      </Route>
      <Route exact path="/admin/activity-log">
        <ActivityLogs />
      </Route>
      {!isDistrictAdmin && <Route exact path="/admin/admin-activity-logs">
        <AdminActivityLogs />
      </Route>}
      <Route path="/" render={() => <Redirect to="/admin/home" />} />
    </Switch>
  );
};

const mapStateToProps = ({ user, property: { notificationToggle } }) => ({
  user,
  notificationToggle,
});

const mapDispatchToProps = (dispatch) => ({});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DashboardAdmin)
);
